import { createAsyncThunk } from "@reduxjs/toolkit";
import type { AppDispatch, RootState } from "@/app/store";
import { log } from "./shared";
import { stopSignalRConnection } from "./stopSignalRConnection";
import { startSignalRConnection } from "./startSignalRConnection";

export const restartSignalRConnection = createAsyncThunk<
  { hub: string },
  string,
  { rejectValue: string; dispatch: AppDispatch; state: RootState }
>("signalr/restart", async (hub, { rejectWithValue, dispatch }) => {
  log("restartSignalRConnection: stopping existing connection if any", { hub });
  await dispatch(stopSignalRConnection());

  log("restartSignalRConnection: starting new connection", { hub });
  const result = await dispatch(startSignalRConnection(hub));

  if (startSignalRConnection.rejected.match(result)) {
    return rejectWithValue(result.payload || "Failed to restart SignalR");
  }

  return result.payload;
});
